@if (snackbar.isOpen()) {
  <div
    class="snack-overlay"
    [class.top]="snackbar.position() === 'top'"
    [class.bottom]="snackbar.position() === 'bottom'">
    <up-snack-bar
      class="snack-bar"
      [isOpen]="true"
      [dismissMills]="snackbar.dismissMills()"
      (isOpenChanged)="handleOpenChange($event)">
      {{ snackbar.message() }}
      <up-button-bar slot="button-bar">
        <up-button button-style="text" (click)="dismiss()">DISMISS</up-button>
      </up-button-bar>
    </up-snack-bar>
  </div>
}